module.exports = "/_next/static/images/kiv-c7a8485ff1f45ba3817cfe22de5264b5.jpg.webp";